import React, { useState } from 'react';
import { bool, any, func } from 'prop-types';
import { FlexContainer, InnerAside, InnerAsideContent } from '../../layouts/Wrapper/Base.components';
import { ConditionalRender } from '../../shared';
import classNames from 'classnames';
import Icon from '../Icon';
import Text from '../Text';

const Header = ({ collapsed, onClick }) => (
    <a
        href='#'
        onClick={() => onClick(!collapsed)}
        className={classNames('drawer-header', { 'collapsed': collapsed })}
        style={{ padding: '45px 15px 0 15px' }}
    >
        <Icon name='filters' right={5} style={{ lineHeight: 1.5 }} />
        <ConditionalRender condition={!collapsed}>
            <Text text='Filtrar por:' />
        </ConditionalRender>
    </a>
);

Header.propTypes = {
    collapsed: bool,
    onClick: func
};

const Wrapper = ({ isMobile, reseting, defaultOpened, children }) => {
    const [collapsed, setCollapsed] = useState(!defaultOpened && true);

    if (isMobile) {
        return (
            <ConditionalRender condition={!reseting}>
                { children }
            </ConditionalRender>
        );
    };
    return (
        <InnerAside closedWidth='40px' background='white' closed={collapsed}>
            <InnerAsideContent>
                <FlexContainer direction='column' minHeight='740px'>
                    <Header collapsed={collapsed} onClick={setCollapsed} />
                    <ConditionalRender condition={!collapsed && !reseting}>
                        { children }
                    </ConditionalRender>
                </FlexContainer>
            </InnerAsideContent>
        </InnerAside>
    );
};

Wrapper.propTypes = {
    isMobile: bool,
    reseting: bool,
    defaultOpened: bool,
    children: any
};

const LeftFilterWrapper = ({ children, ...props }) => {
    return (
        <Wrapper {...props}>
            { children }
        </Wrapper>
    );
};

LeftFilterWrapper.propTypes = {
    children: any
};

LeftFilterWrapper.defaultProps = {
    children: null
};

export default LeftFilterWrapper;
